var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select-type", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { scrollTop: 300 } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        _c("div", { staticClass: "flex-column main" }, [
          _c(
            "div",
            {
              staticClass: "back",
              on: {
                click: function ($event) {
                  return _vm.goBack()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c("div", { staticClass: "title" }, [_vm._v("选择公会类型")]),
          _c(
            "div",
            {
              staticClass: "flex-row-h-center type-item",
              on: {
                click: function ($event) {
                  return _vm.goStepOne("1")
                },
              },
            },
            [_vm._m(0), _vm._m(1), _vm._m(2)]
          ),
          _c(
            "div",
            {
              staticClass: "flex-row-h-center type-item",
              on: {
                click: function ($event) {
                  return _vm.goStepOne("2")
                },
              },
            },
            [_vm._m(3), _vm._m(4), _vm._m(5)]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-left" }, [
      _c("img", {
        attrs: { src: require("@/assets/type/company.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-center" }, [
      _c("div", { staticClass: "center-title" }, [_vm._v("企业公会")]),
      _c("div", { staticClass: "flex-row-h-center center-dec" }, [
        _vm._v("营业执照"),
      ]),
      _c("div", { staticClass: "flex-row-h-center center-dec" }, [
        _vm._v("负责人身份信息"),
      ]),
      _c("div", { staticClass: "flex-row-h-center center-dec" }, [
        _vm._v(">5个达人主播"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-right" }, [
      _c("img", {
        attrs: { src: require("@/assets/type/arrow-type.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-left" }, [
      _c("img", { attrs: { src: require("@/assets/type/mine.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-center" }, [
      _c("div", { staticClass: "center-title" }, [_vm._v("个人公会")]),
      _c("div", { staticClass: "flex-row-h-center center-dec" }, [
        _vm._v("负责人身份信息"),
      ]),
      _c("div", { staticClass: "flex-row-h-center center-dec" }, [
        _vm._v(">5个达人主播"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-right" }, [
      _c("img", {
        attrs: { src: require("@/assets/type/arrow-type.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }